import { render, staticRenderFns } from "./SupplierContactOrdersView.vue?vue&type=template&id=e3c7db04&scoped=true&"
import script from "./SupplierContactOrdersView.vue?vue&type=script&lang=js&"
export * from "./SupplierContactOrdersView.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContactOrdersView.vue?vue&type=style&index=0&id=e3c7db04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c7db04",
  null
  
)

export default component.exports